/**
 * 配置
 *
 * @author chitanda
 * @date 2021-03-18 10:03:02
 * @export
 * @interface ContextMenuOptions
 */
export interface ContextMenuOptions {
  /**
   * 显示层级，未显示
   *
   * @author chitanda
   * @date 2021-03-18 10:03:58
   * @type {number}
   */
  zIndex?: number;
  /**
   * 菜单宽度
   *
   * @default 230
   * @author chitanda
   * @date 2021-03-18 10:03:02
   * @type {number}
   */
  minWidth?: number;
  /**
   * 子菜单打开模式
   *
   * @author chitanda
   * @date 2021-07-29 14:07:23
   * @type {('hover' | 'click')}
   */
  subOpenType?: 'hover' | 'click';
}
